import { axiosInstanceV1 } from "@rentablo/api";
import { Invoice } from "../model";

export const getInvoices = async (token: string | undefined) => {
  const response = await axiosInstanceV1.get<{ invoices: Invoice[] }>(
    "/billingCycles/invoices",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const downloadInvoice = async (
  token: string | undefined,
  id: number
) => {
  const response = await axiosInstanceV1.get<File>(
    `/billingCycles/${id}/invoices?format=pdf`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    }
  );
  return {
    data: response.data,
    name: response.headers["content-disposition"] as string,
  };
};
